<template>
  <div class="container-fluid">
    <div class="row">
      <h5 class="col-2">
        Filtros
      </h5>
      <div class="col-3">
        <div class="input-group mb-1">
          <div class="input-group-prepend">
            <span class="input-group-text"> Entidad </span>
          </div>
          <select v-model="filterEntity" class="custom-select" @change="onChange">
            <option value="ALL">
              Todos
            </option>
            <option value="TICKET">
              TICKET
            </option>
            <option value="CORE">
              CORE
            </option>
          </select>
        </div>
      </div>
      <div class="col-1 date-filter-title">
        <b>Filtrado por Fechas:</b>
      </div>
      <div class="col-4">
        <div class="filter-date-between">
          <div class="input-group mb-1">
            <div class="input-group-prepend">
              <span class="input-group-text"> Desde </span>
            </div>
            <input v-model="selectedDate.from" type="date" class="form-control" placeholder="desde">
          </div>
          <div class="input-group mb-1">
            <div class="input-group-prepend">
              <span class="input-group-text"> Hasta </span>
            </div>
            <input v-model="selectedDate.to" type="date" class="form-control" placeholder="hasta">
          </div>
        </div>
      </div>
      <div class="col-2 filter-actions">
        <button class="btn btn-primary">
          Filtrar
        </button>
        <br>
        <button class="btn btn-danger">
          Quitar
        </button>
      </div>
    </div>
    <hr>

    <el-table v-loading="listLoading" :data="logList" element-loading-text="Cargando..." border fit highlight-current-row>
      <!-- <el-table-column type="selection" align="center" /> -->
      <el-table-column label="Fecha Ingreso" width="150">
        <template slot-scope="scope">
          {{ formatDate(scope.row.date, true) }}
        </template>
      </el-table-column>
      <el-table-column label="Titulo" width="150">
        <template slot-scope="scope">
          {{ scope.row.title }}
        </template>
      </el-table-column>
      <el-table-column label="Descripcion">
        <template slot-scope="scope">
          {{ scope.row.description }}
        </template>
      </el-table-column>
      <el-table-column label="Entidad" width="95">
        <template slot-scope="scope">
          {{ scope.row.entity }}
        </template>
      </el-table-column>
      <el-table-column label="Id Entidad" width="95">
        <template slot-scope="scope">
          {{ scope.row.entityId }}
        </template>
      </el-table-column>
      <el-table-column label="Tipo" width="95">
        <template slot-scope="scope">
          {{ scope.row.type }}
        </template>
      </el-table-column>
      <el-table-column label="Nombre de Usuario" width="155">
        <template slot-scope="scope">
          {{ scope.row.username }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import LogService from '@/services/log.service';
import { formatDate } from '@/utils/page-utils';

export default {
    data() {
        return {
            logList: null,
            listLoading: true,
            selectedDate: {
                from: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().substr(0, 10),
                to: new Date().toISOString().substr(0, 10)
            },
            filterEntity: 'ALL'
        };
    },
    methods: {
        initLogsComponent() {
            this.listLoading = true;
            this.getLogs();
        },
        getLogs() {
            if (!this.logList) {
                LogService.getLogs().then(
                    response => {
                        this.logList = response.data;
                        this.listLoading = false;
                    },
                    error => {
                        console.log(error.response && error.response.data ||
                  error.message || error.toString());
                    }
                );
            } else {
                // already have'em
                this.listLoading = false;
            }
        },
        formatDate,
        filter() {
            this.getLogs();
        },
        onChange() {

        },
        removeFilter() {
            this.getLogs();
        }
    }
};
</script>
